// extracted by mini-css-extract-plugin
export var banner = "_24-0";
export var icon = "_24-1";
export var message = "_24-2";